import { Paginator } from '@app/classes';
import { CompanyDocument } from '@app/models/documents/company-document.model';
import { DocumentAcknowledgement } from '@app/models/documents/document-acknowledgement.model';
import { SignatureRequest } from '@app/models/documents/signature-request.model';
import { Column } from '@app/modules/table/classes/column.class';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';

import { Model } from '@app/models/core/base.model';
import {
    AcknowledgementStatusColumn,
    AssigneeColumn,
    CreatedAtColumn,
    RequestedAtColumn,
    SignatureRequestStatusColumn,
} from './columns';
import { CosignersColumn } from './columns/signature-requests/cosigners.column';

interface Completable extends Model {
    isComplete: () => boolean;
}

const remindOption: MenuColumnItem = {
    label: 'document.remind',
    event: 'remind',
};

const deleteOption: MenuColumnItem = {
    label: 'document.delete',
    event: 'delete',
};

const downloadOption: MenuColumnItem = {
    label: 'document.download',
    event: 'download',
};

export class CompanyDocumentAssignmentsTable extends Table {
    showMenuColumnOptions = true;
    unnavigableLink = true;

    constructor(
        protected auth: AuthService,
        private companyDocument: CompanyDocument
    ) {
        super(auth);
        this.boot();
    }

    getMenuColumnOptionsForRow(assignment: Completable): MenuColumnItem[] {
        const completeOptions: MenuColumnItem[] = [];

        if (assignment instanceof SignatureRequest) {
            completeOptions.push(downloadOption);
        }

        return assignment.isComplete() ? completeOptions : [remindOption, deleteOption];
    }

    setColumns(): void {
        const typeSpecificColumns: Column[] = this.companyDocument.isStandardSigningDocument()
            ? this.getSignatureRequestColumns()
            : this.getAcknowledgementRequestColumns();

        this.columns = [new AssigneeColumn(), ...typeSpecificColumns];
    }

    setDataSource(): void {
        this.paginator = this.companyDocument.isStandardSigningDocument()
            ? new Paginator(
                  SignatureRequest.param('signingTemplate', this.companyDocument.signingTemplate.id).with([
                      'employee',
                      'cosigners.employee',
                      'file',
                  ])
              )
            : new Paginator(DocumentAcknowledgement.param('companyDocument', this.companyDocument.id).with('employee'));
    }

    private getAcknowledgementRequestColumns(): Column[] {
        return [new CreatedAtColumn(), new AcknowledgementStatusColumn()];
    }

    private getSignatureRequestColumns(): Column[] {
        let columns = [new RequestedAtColumn(), new SignatureRequestStatusColumn()];

        if (this.companyDocument.signingTemplate.isMultiSigner()) {
            columns = [new CosignersColumn(), ...columns];
        }

        return columns;
    }
}
